import { listRecords, deleteRecord, mediaUrl, MEDIA_BUCKET } from './supabase';
import { createContent } from './contentUtils';
async function getMedia(type) {
    return (await listRecords('content', { type })).map(row => ({
        ...row, description: row.content, fileUrl: mediaUrl(MEDIA_BUCKET, row.imageId),
        date: row.dateLabel || new Date(row.createdAt).toLocaleDateString('en-US', { timeZone: 'America/Antigua' }),
    }));
}
export const photoUtils = {
    createPhoto: ({ title, description, category, file, fileType = 'photo' }) =>
        createContent({ title, content: description, category, file, type: fileType }),
    getPhotos: () => getMedia('photo'),
    getVideos: () => getMedia('video'),
    deletePhoto: id => deleteRecord('content', id),
};
